module.exports = __webpack_public_path__ + "static/img/03委屈.0bb94f6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/03委屈.gif
// module id = 5XGd
// module chunks = 0